export const Column=()=> [
    {
        Header: 'User Name',
        accessor:'name'
    },
    {
        Header: 'Phone',
        accessor:'phone'
    },
    {
        Header: 'Gmail',
        accessor:'email'
    },

]

